export default __webpack_public_path__ + "static/media/form_logo_word.cb882139.svg";